import { Box, Container } from '@mui/material';
import { useTranslation } from 'next-i18next';
import { FC, useLayoutEffect } from 'react';

import styles from './TermsOfUse.module.scss';

export const TermsOfUse: FC = () => {
  const { t } = useTranslation('common');

  useLayoutEffect(() => {
    window.addEventListener('contextmenu', (e) => {
      e.preventDefault();
    });

    return () => window.removeEventListener('contextmenu', () => {});
  }, []);

  const handleCopy = (e: any) => {
    e.preventDefault();
  };

  return (
    <Box className={styles.textWrapper}>
      <Container maxWidth={'md'} sx={{ margin: '56px auto' }} onCopy={handleCopy}>
        <h1>{t('footer.links.terms')}</h1>
        <h2>NOTICE</h2>
        <p>
          Please read these website terms of use carefully. By accessing this site, you agree to be bound by the
          following terms of use. If you do not agree to these terms of use, please do not access this site or any of
          its pages.
        </p>
        <h2>INTELLECTUAL PROPERTY RIGHTS</h2>
        <p>
          The copyright of the pages and screens displaying the pages, as well as the information and materials on them
          and their location, belongs to LEAD GATES LTD, a company registered in Bulgaria with its registered office at
          APT. 20, FL. 6, 14 MIZIYA STR., TOWN OF PLOVDIV under the brand &quot;Smart Gates&quot; (hereinafter referred
          to as &quot;Smart Gates&quot; &quot;), unless otherwise indicated. The trademarks, logos and service marks
          displayed on this site are the property of Smart Gates, its Affiliates, Subsidiaries and Partners. Nothing on
          this site shall be construed as conferring, by implication, by estoppel or otherwise, any license or right to
          use any trademark, logo or service mark displayed on this site without the prior written permission of the
          owner of the mark. All the information and content available on the site is protected by copyright. Users of
          the Site are prohibited from modifying, copying, distributing, transmitting, displaying, publishing, selling,
          licensing, creating derivative works from or otherwise using any information and content on or through the
          Site for commercial, public or other unauthorized purposes.
        </p>
        <h2>USE OF INFORMATION AND MATERIALS</h2>
        <p>
          The information and materials contained on these pages, as well as the terms of use set forth herein, are
          subject to change without notice. Unauthorized use of the Website and Smart Gates systems or misuse of any
          information posted on the Site is strictly prohibited. Not all products and services are available in all
          geographic regions. Eligibility for certain products and services is subject to final determination by Smart
          Gates and/or its affiliates.
        </p>
        <h2>LINKS AND REFERENCES</h2>
        <p>
          This site may contain links and/or links to websites (e.g., trademarks) controlled or offered by third parties
          not affiliated with Smart Gates. Smart Gates hereby disclaims any liability for any information, materials,
          products or services posted or offered on any third-party site. Smart Gates does not endorse or recommend any
          information, products or services offered on any third-party site, and Smart Gates is not responsible for any
          failure of products or services offered or advertised on any third-party site. Smart Gates is not responsible
          for the content of any such third-party site. Such third party may have a different privacy policy than that
          of Smart Gates, and such third-party site may provide less security than the Smart Gates site.
        </p>
        <h2>NO WARRANTY</h2>
        <p>
          The information and materials contained on this site, including text, graphics, links or other elements, are
          provided &quot;as is&quot; &quot;as available&quot;. Smart Gates does not warrant the accuracy, adequacy or
          completeness of this information and materials and expressly disclaims liability for errors or omissions in
          this information and materials. No warranties of any kind, implied, express or statutory, including but not
          limited to warranties of non-infringement, title, merchantability, fitness for a particular purpose and
          freedom from computer viruses, are given in conjunction with the information and materials, available on this
          website. Smart Gates assumes no responsibility for any errors or omissions in the content of this site.
        </p>
        <h2>LIMITATION OF LIABILITY</h2>
        <p>
          Under no circumstances shall Smart Gates be liable for any damages, including, without limitation, direct or
          indirect, special, incidental or consequential damages, damages or expenses, arising out of or in connection
          with this site or any linked site or its use or inability to use any party, or in connection with any failure
          or performance, error, omission, interruption, defect, delay in operation or transmission, computer virus or
          line or system failure, even if Smart Gates or its representatives are alerted to the possibility of such
          damage, loss or expense.
        </p>
        <h2>SUBMISSIONS</h2>
        <p>
          All information provided to Smart Gates through this site is considered and remains the property of Smart
          Gates, and Smart Gates is free to use any ideas, concepts, know-how or techniques contained in the information
          that a visitor to this site provides to Smart Gates through this site. Smart Gates has no obligation of
          confidentiality with respect to the information provided, except as agreed by a Smart Gates legal entity that
          has a direct relationship with customers, or as otherwise specifically mentioned in the Smart Gates Privacy
          Policy, or required by law. Nothing contained herein shall be construed as limiting or reducing Smart
          Gates&apos; liability and obligations to customers under smart Gates&apos; Privacy Policy.
        </p>
        <h2>AVAILABILITY</h2>
        <p>
          This site is not intended for distribution or use by any person or entity in any jurisdiction or country where
          such distribution or use would be contrary to local law or regulation.
        </p>
        <h2>CHANGES TO THE TERMS OF USE</h2>
        <p>
          Smart Gates reserves the right to revise these Terms of Use at any time without notice. Users of the Site are
          deemed to be informed of and bound by any changes to these Terms of Use. You agree to review these Terms of
          Use regularly, and your continued access to or use of this Site constitutes your acceptance of any changes.
        </p>
        <h2>GOVERNING LAW</h2>
        <p>
          Users of this website hereby consent to the exclusive jurisdiction and venue of the courts of Bulgaria in all
          disputes (a) arising out of or relating to this website and/or these Terms of Use, (b) in which this website
          and/or these Terms of Use and/or these Terms of Use are a matter of fact.
        </p>
        <h2>GENERAL</h2>
        <p>
          Use of this site is unauthorized (a) in any manner that does not give full effect to all provisions of these
          Terms of Use and (b) any jurisdiction where use of this Site may violate any legal requirements. As a result
          of these Terms of Use or your use of this site, there is no joint venture, partnership, employment or agency
          relationship. These Terms of Use constitute the entire agreement between you and Smart Gates with respect to
          this site and supersede any previous or current communications and suggestions, whether electronic, oral or
          otherwise, between you and Smart Gates with respect to this site. No changes to these Terms of Use will be
          effective without the express permission of an official of Smart Gates.
        </p>
        <h2>CONTACTING US</h2>
        <p>If you have any questions about these Terms of Use, please contact us at:</p>
        <p>support@smart-gates.net</p>
      </Container>
    </Box>
  );
};
